import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async Thunk to Verify GST Number
export const verifyGSTIN = createAsyncThunk(
  "gst/verifyGSTIN",
  async (gstNumber, { rejectWithValue }) => {
    try {
      // Uncomment this when API is ready
      /*
      const response = await axios.post(
        "https://verify.rechargkit.biz/recharge/gstinVerify",
        { GSTIN: gstNumber },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer YOUR_ACCESS_TOKEN_HERE`,
          },
        }
      );
      return response.data;
      */

      // Mock response (REMOVE this when real API is available)
      if (gstNumber === "21AAACQ3222B1ZE") {
        return mockGSTData;
      } else {
        throw new Error("Invalid GST Number");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to verify GST.");
    }
  }
);

// Mock API Response
const mockGSTData = {
  error: 0,
  success: 1,
  data: {
    reference_id: 1235860,
    GSTIN: "21AAACQ3222B1ZE",
    legal_name_of_business: "APPTIMATE SOFTWARE PRIVATE LIMITED",
    trade_name_of_business: "APPTIMATE SOFTWARE PRIVATE LIMITED",
    center_jurisdiction: "BHUBANESWAR III RANGE",
    state_jurisdiction: "Bhubaneswar II Circle",
    date_of_registration: "2017-07-01",
    constitution_of_business: "Private Limited",
    taxpayer_type: "Regular",
    gst_in_status: "Active",
    last_update_date: "2023-06-22",
    nature_of_business_activities: ["Office / Sale Office"],
    principal_place_address:
    "7th floor, esplanade one mall, unit no -725, Bhubaneswar, Rasulgarh Square, Odisha, 751010",
    principal_place_split_address: {
      building_name: "esplanade one mall",
      street: "Rasulgarh Square",
      location: "Bhubaneswar",
      building_number: "unit no -725",
      district: "",
      state: "Odisha",
      city: "",
      flat_number: "7th floor",
      latitude: "20.2949736105611",
      longitude: "85.8576319041584",
      pincode: "751010",
    },
    valid: true,
    message: "GSTIN Exists",
  },
  msg: "success",
};

// GST Slice
const gstSlice = createSlice({
  name: "gst",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    // Clears GST Data when user doesn't have a GST number
    clearGSTData: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyGSTIN.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyGSTIN.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(verifyGSTIN.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearGSTData } = gstSlice.actions;
export default gstSlice.reducer;
